import { apiEmpleo } from "../../util/ApiEmpleo";
import { TApiCollectionResponse } from "../apiCoreV2.types";
import { TGetClientDiscardedValuationsCollectionItem } from "./valuation.types";

export interface IApiListClientDiscardedValuationsParams {
  candidateId: string;
}

export const apiListClientDiscardedValuations = async (
  params: IApiListClientDiscardedValuationsParams
) => {
  let res: TApiCollectionResponse<TGetClientDiscardedValuationsCollectionItem> =
    await apiEmpleo.get(`valoraciones/client-discarded/${params.candidateId}`);

  return res;
};
